export default "__VITE_ASSET__w47MFp6l__"